// extracted by mini-css-extract-plugin
module.exports = {"form":"CustomerModule_form__36iIj","formMain":"CustomerModule_formMain__2O3j9","formSidebar":"CustomerModule_formSidebar__229xR"};